import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { AuthShell } from "@/business/components/AuthShell";
import { loginBusiness, MOCK_BUSINESS_API } from "@/business/api";

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({ email: "", password: "" });

  const upd = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await loginBusiness(form);
      const name = res?.user?.business_name || "venue owner";
      toast.success(`Welcome back, ${name}!`);
      navigate("/business/dashboard", { replace: true });
    } catch (e2) {
      setErr(e2?.message || "Login failed.");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to your venue dashboard."
      footer={(<>New to BuskerBeat for Business?{" "}<Link to="/business/signup" className="text-[#FF6A00] font-medium hover:underline" data-testid="login-signup-link">Create an account</Link></>)}
    >
      {MOCK_BUSINESS_API && (
        <div className="mb-4 rounded-lg border border-[#FFD7BF] bg-[#FFF1E8] text-[#B54708] text-xs px-3 py-2" data-testid="login-mock-banner">
          <strong>Preview mode:</strong> sign in with the same email you used during signup on this device.
        </div>
      )}
      <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form" noValidate>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" data-testid="login-email-input" type="email" value={form.email} onChange={upd("email")} placeholder="you@venue.com" required autoComplete="email" />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <button type="button" className="text-xs text-[#6B7280] hover:text-[#111827]" data-testid="login-forgot-password-button" onClick={() => toast("Password reset is coming soon. Contact support for help.")}>Forgot?</button>
          </div>
          <Input id="password" data-testid="login-password-input" type="password" value={form.password} onChange={upd("password")} placeholder="Your password" required autoComplete="current-password" minLength={6} />
        </div>
        {err && (
          <div role="alert" data-testid="login-error-text" className="text-sm text-[#DC2626] bg-red-50 border border-red-200 rounded-md px-3 py-2">{err}</div>
        )}
        <Button type="submit" disabled={loading} data-testid="login-submit-button" className="w-full bg-[#FF6A00] hover:bg-[#E85F00] text-white">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Sign in
        </Button>
      </form>
    </AuthShell>
  );
}
